<template>
    <div component="AdminStatistics">
        <v-dialog v-model="showProjectList" persistent>
            <v-card min-width="300px" component="ProjectList">
                <v-card-title>
                    <span v-if="selectedCustomer && getSelectedCustomer && getSelectedCustomer.name">
                        {{ getSelectedCustomer.name }}
                    </span>
                    <span v-else> Order list </span>
                    <v-icon @click="(showProjectList = false), (selectedCustomer = null)" class="close-modal">
                        close
                    </v-icon>
                </v-card-title>
                <v-card-text style="height: 50vh" scrollable class="px-0">
                    <v-list>
                        <v-list-item v-for="project in getLastMonthProjectList" :key="`project-${project.id}`">
                            <v-col cols="5">
                                {{ project.nazov }}
                            </v-col>
                            <v-col cols="2" class="text-right">
                                <v-icon class="detail-icon" @click="setProjectDetail(project)">info</v-icon>
                            </v-col>
                            <v-col cols="5" class="text-right">
                                {{ `${project.price.with_dph} €` }}
                            </v-col>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showProjectDetail" max-width="500" no-click-animation persistent hide-overlay>
            <v-card component="ProjectDetailDialog">
                <v-card-title>
                    <b>{{ projectDetail.nazov }}</b>
                    <v-icon @click="(showProjectDetail = false), (projectDetail = {})" class="close-modal">
                        close
                    </v-icon>
                </v-card-title>
                <v-card-text>
                    <div>
                        <p class="color-blue"><b>SHORTLIST</b> was send for approval.</p>
                        <small>On {{ getDateWithTime(projectDetail.schvalenie_odoslane) }}</small>
                    </div>
                    <v-text-field
                        label="To this email address"
                        disabled
                        hide-details
                        :value="projectDetail.schvalenie_email"
                    ></v-text-field>
                    <div>
                        <p class="color-blue"><b>SHORTLIST</b> was approved.</p>
                        <small>On {{ getDateWithTime(projectDetail.datum_schvalenia) }}</small>
                    </div>
                    <hr />
                    <div v-if="projectDetail.prolongs && projectDetail.prolongs.length > 0" class="d-flex flex-column">
                        <p class="color-blue"><b>SHORTLIST</b> was prolonged.</p>
                        <small v-for="date in projectDetail.prolongs" :key="`prolongs-${date.id}`"
                            >On {{ getDateWithTime(date.created_at) }}</small
                        >
                    </div>
                    <div v-else>
                        <p class="color-blue"><b>SHORTLIST</b> was not prolonged yet.</p>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <page-header :icon="'videocam'" :text="'Admin Statistics'" :loading="loading"></page-header>
        <v-card container="main">
            <v-row>
                <v-col cols="9" class="align-center"><b>Order count last month:</b></v-col>
                <v-col cols="3" class="text-right">
                    <v-btn :disabled="loading || customerLoading" small @click="openLastMonthProject()">
                        {{ getProjectCountLastMonth }}
                    </v-btn>
                </v-col>
            </v-row>

            <div v-if="hasRole('role_owner')" component="AdminCustomerStatistics">
                <page-header
                    class="px-0"
                    :icon="'videocam'"
                    :text="'Admin Customer Statistics'"
                    :loading="customerLoading"
                ></page-header>
                <v-row class="customer-item" v-for="customer in getCustomers" :key="`customer-${customer.id}`">
                    <v-col cols="12" class="customer-item-name"> {{ customer.name }} </v-col>
                    <v-col cols="9" class="align-center"><b>Order count last month:</b></v-col>
                    <v-col cols="3" class="text-right">
                        <v-btn :disabled="loading || customerLoading" small @click="openLastMonthProject(customer.id)">
                            {{ customer.count }}
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';
import moment from 'moment';

export default {
    name: 'AdminStatistics',

    data() {
        return {
            fatalError: false,
            loading: true,
            customerLoading: true,
            maintainer: true,
            showProjectList: false,
            showProjectDetail: false,
            selectedCustomer: false,
            projectDetail: {},
        };
    },

    async mounted() {
        await this.loadStatistics();

        if (this.hasRole('role_owner')) {
            await this.loadCustomerStatistics();
        }

        this.loading = false;
        this.customerLoading = false;
    },

    methods: {
        ...mapActions(['loadStatistics', 'loadCustomerStatistics', 'loadLastMonthProjectList']),

        ...mapMutations(['showCustomerProjects', 'setEmptySelectedCustomer']),

        setProjectDetail(project) {
            this.projectDetail = project;
            this.showProjectDetail = true;
        },

        getDateWithTime(date) {
            return `${moment(date).format('YYYY.MM.DD')} at ${moment(date).format('HH:mm')}`;
        },

        async openLastMonthProject(customer_id) {
            this.loading = true;
            this.selectedCustomer = customer_id;

            if (customer_id) {
                this.showCustomerProjects(customer_id);
            } else {
                await this.loadLastMonthProjectList();
            }

            this.showProjectList = true;
            this.loading = false;
        },
    },

    computed: {
        ...mapGetters([
            'getProjectCountLastMonth',
            'getLastMonthProjectList',
            'getCustomers',
            'getSelectedCustomer',
            'hasRole',
        ]),
    },

    components: {
        PageHeader,
    },

    watch: {},
};
</script>

<style lang="less" scoped>
@import '~@variables';

.align-center {
    display: flex;
}

.text-right {
    .v-btn {
        color: inherit;
        background: inherit;
    }
}

.close-modal {
    padding: 0;
    background: inherit;
    color: inherit;
    margin-left: auto;
}

.detail-icon {
    padding: 0;
    background: inherit;
    color: inherit;
}

[component='ProjectDetailDialog'],
[component='ProjectList'] {
    position: relative;
    p {
        margin-bottom: 0;
    }

    .v-card__title {
        background: @primary_dk;
        border-bottom: 1px solid @primary;
    }
}

[component='AdminCustomerStatistics'] {
    margin-top: 1rem;
    position: relative;

    .customer-item {
        border-bottom: 1px solid @primary;

        &-name {
            padding-bottom: 5px;
            font-size: 1.5rem;
        }

        .align-center,
        .text-right {
            padding-top: 5px;
        }
    }

    .customer-item + .customer-item {
        border-bottom: none;
    }
}

[component='AdminStatistics'] {
    height: 100%;
    overflow: hidden;

    .row {
        margin: 0;
    }

    [container='main'] {
        padding: 0px 30px 10px 30px;
        display: flex;
        flex-direction: column;
        max-width: 100%;
        background: transparent;
        box-shadow: none;

        & > .row {
            flex-grow: 0;
        }
    }
}
</style>
